export const BehaviorConfigKeys = {
  all: ['behaviorConfigs'] as const,
  lists: () => [...BehaviorConfigKeys.all, 'list'] as const,
  list: (queryParams: string) => [...BehaviorConfigKeys.lists(), { queryParams }] as const,
  details: () => [...BehaviorConfigKeys.all, 'detail'] as const,
  detail: (id: string) => [...BehaviorConfigKeys.details(), id] as const,
  displayPages: () => [...BehaviorConfigKeys.all, 'displayPages'],
  specialties: () => [...BehaviorConfigKeys.all, 'specialties'],
};
